


















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetPatientPartDetail } from "@/request/hdr";
import PicPreview from "@/components/pic-preview.vue";
import TimeTab from "./time-tab.vue";
@Component({
  components: {
    PicPreview,
    TimeTab
  }
})
export default class CommonTongueBasis extends Vue {
  @Prop()
  private patientId: any;
  private message: any = {};
  private current: any = {
    舌象照片: {},
    舌色参数: [],
    苔色参数: []
  };
  private ifShowPicPreview: boolean = false;
  private picUrl: any = "";
  private changeCurrentItem(item) {
    this.$set(this, "current", item);
  }
  /**
   * @description 打开预览图
   */
  private showPreview(url) {
    this.picUrl = url;
    this.ifShowPicPreview = true;
  }
  /**
   * @description 获得患者某部分信息
   */
  private fetchPatientPartDetail() {
    GetPatientPartDetail(this, this.patientId, "舌象基础").then((data: any) => {
      this.message = data;
      if (this.message && this.message.length > 0) {
        this.current = this.message[0];
      }
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchPatientPartDetail();
  }
}
